import { t } from '@/plugins/i18n'
import { isUrl, onlyHttps, zhjaReg } from '@/plugins/utils'
// import { Ref } from 'vue'
const rules: any = {
  plainEn(rule: any, val: string, callback: any) {
    if (/^[a-zA-Z\s-,]+$/.test(val.trim())) {
      callback()
    } else {
      callback(t('仅限输入英文字符'))
    }
  },
  plain(rule: any, val: string, callback: any) {
    if (/^[\da-zA-Z\s-]+$/.test(val.trim())) {
      callback()
    } else {
      callback(t('仅限输入英文和数字字符'))
    }
  },
  plain2(rule: any, val: string, callback: any) {
    if (/^[\da-zA-Z]+(\.[\d])?$/.test(val.trim())) {
      callback()
    } else {
      callback(t('仅限输入英文和数字字符'))
    }
  },
  // 韩国名称非必填填了需要校验韩文
  koNameNoRequire(rule: any, val: string, callback: any) {
    if (!val || /^[\uac00-\ud7ff]+$/.test(val.trim())) {
      callback()
    } else {
      callback(t('仅限输入韩文'))
    }
  },
  koName(rule: any, val: string, callback: any) {
    if (/^[\uac00-\ud7ff]+$/.test(val.trim())) {
      callback()
    } else {
      callback(t('仅限输入韩文'))
    }
  },
  noblank(rule: any, val: string, callback: any) {
    if (val.trim() === '') {
      callback(t('无效内容'))
    } else {
      callback()
    }
  },
  phone(rule: any, val: string, callback: any) {
    if (/^[\d-]{6,20}$/.test(val)) {
      callback()
    } else {
      callback(t('无效的手机号码'))
    }
  },
  apiPhone(rule: any, val: string, callback: any) {
    if (/^[\d- +]{6,20}$/.test(val)) {
      callback()
    } else {
      callback(t('无效的手机号码'))
    }
  },
  address(rule: any, val: string, callback: any) {
    // // 去除空格
    // const text = val.replace(/\s/g, '')
    // // 不能只有数字
    // if (/^\d+$/.test(text)) { return callback(t('无效的地址')) }
    // // 只能是数字、英文、中日文
    // if (!(new RegExp(`^[${zhjaReg}|a-z|A-Z|\\d]{4,}$`)).test(text)) { return callback(t('无效的地址')) }
    // // 中日文必须大于4字符？
    // const words = text.match(new RegExp(`[${zhjaReg}]{1}`, 'g'))
    // if (!words || words.length < 4) {
    //   return callback(t('无效的地址'))
    // }
    // return callback()
    if (val.trim() === '') {
      callback(t('无效内容'))
    } else {
      callback()
    }
  },
  email(rule: any, val: string, callback: any) {
    if (!/[\d\w-]+@([a-zA-ZA-z0-9-]+\.)+[a-z]+/.test(val)) {
      callback(t('邮箱格式不正确，请重新输入'))
    } else {
      callback()
    }
  },
  postalCode(rule: any, val: string, callback: any) {
    if (/^[\da-zA-Z- ]{1,20}$/.test(val)) {
      callback()
    } else {
      callback(t('无效的邮编'))
    }
  },
  postal(rule: any, val: string, callback: any) {
    if (/(^\d{3}-?\d{4}$)|(^\d{7}$)/.test(val)) {
      callback()
    } else {
      callback(t('无效的邮编'))
    }
  },
  url(rule: any, val: string, callback: any) {
    if (isUrl(val)) {
      callback()
    } else {
      callback(t('无效的URL'))
    }
  },
  // https (rule: any, val: string, callback: any) {
  //   if (onlyHttps(val)) {
  //     callback()
  //   } else {
  //     callback(t('无效的URL'))
  //   }
  // },
  deliver(rule: any, val: string, callback: any) {
    // const words = val.trim().split(/\b\s+\b/)
    // const text = words.join('')
    // // 整个字段空格大于1且空格不连续
    // if (words.length > 2) { return callback(t('无效内容')) }
    // // 收件人名带有“株”或者“LTD”字样时报错
    // if (val.match(/株|LTD/i)) { return callback(t('无效内容')) }
    // // 只能是英文且...?
    // if (/^[a-zA-Z]{1,10}$/.test(text)) { return callback() }
    // // 只能是中日文且...?
    // if ((new RegExp(`^[${zhjaReg}]{1,6}$`)).test(text)) { return callback() }
    // //
    // return callback(t('无效内容'))
    if (val.trim() === '') {
      callback(t('无效内容'))
    } else {
      callback()
    }
  },
  country(rule: any, val: string, callback: any) {
    if (!val) {
      callback(val)
    } else {
      callback()
    }
  },
  address40(rule: any, val: string, callback: any) {
    if (val.trim() === '') {
      callback(t('无效内容'))
      return
    }
    if (val && val.length > 40) {
      callback(t('详细地址不能超过40个字符'))
      return
    }
    callback()
  },
  clearanceCode(rule: any, val: string, callback: any) {
    if (!val) {
      callback(val)
    } else {
      callback()
    }
  }
}

export const useRule = (key: any, trigger = 'blur'): any => {
  const validator = (rule: any, val: string, callback: any) => {
    if (!val) {
      callback()
    } else {
      if (typeof key === 'string') {
        rules[key](rule, val, callback)
      }
    }
  }
  return [
    {
      validator,
      trigger
    }
  ]
}

export const rule = (validator: any, trigger = 'blur') => {
  return [{
    validator: (rule: any, val: any, callback: any) => {
      const msg = validator(val)
      callback(msg)
    },
    trigger
  }, { required: true, trigger }]
}

export const useMust = (message: any, trigger = 'blur'): any[] => {
  return [{ required: true, message, trigger }]
}

export default (key: any, trigger = 'blur'): any[] => {
  return useMust(key.message, trigger).concat(useRule(key.key, trigger))
}

// 符合N个条件即可通过
export const atleast = (fns: any, least = 1): boolean => {
  let num = 0
  fns = Array.isArray(fns) ? fns : [fns]
  return fns.some((v: any) => {
    if (v()) num++
    return num >= least
  })
}
export const useLeast = (options: any, trigger = 'blur'): any[] => {
  const { fns, msg } = options
  return [
    {
      validator(rule: any, val: string, callback: any) {
        if (atleast(fns)) {
          callback()
        } else {
          callback(msg)
        }
      },
      trigger
    }
  ]
}

//
export const pipe = (oks: any, fail: any): any => {
  return oks
    .reduce((acc: any, fn: any) => {
      return acc.then(() => {
        const res = fn()
        if (!res) throw new Error('')
      })
    }, Promise.resolve())
    .catch(fail)
}
